<template>
  <v-container fluid grid-list-lg @keyup.esc="clear" ref="modal">
    <v-row>
      <v-col>
        <span
          class="headline font-weight-regular"
          v-bind:class="moveTitleClassObject"
        >
          Dashboard
          <v-icon>mdi-chevron-double-right</v-icon>
          Pac Consolidado dfd
        </span></v-col
      >
      <v-col md="auto">
        <v-btn text dark mediun color="secondary" @click="loadData">
          <v-icon dark>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        <excell
          :items="pacsMisCpcs"
          :headers="xlsxHeaders"
          :fieldValues="xlsxFields"
        ></excell>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col>
        <v-alert
          v-model="drawer"
          icon="mdi-lightbulb-outline"
          prominent
          border="left"
          text
          type="info"
          transition="fade-transition"
        >
          Haga click en <v-icon color="info">mdi-magnify</v-icon> para abrir el
          buscador.
        </v-alert>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col>
        <v-alert
          v-model="moreItems"
          icon="mdi-lightbulb-outline"
          prominent
          border="left"
          text
          color="primary"
          transition="fade-transition"
        >
          <v-row align="center">
            <v-col class="grow">
              Se han encontrado más resultados que coinciden con su criterio de
              búsqueda en "Descripción de la compra" en otros códigos CPC´s que
              no constan en su Registro Único de Proveedor (RUP)</v-col
            >
            <v-col class="shrink">
              <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" v-on="on">VER ITEMS</v-btn>
                </template>
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Otros Items</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                    <v-toolbar-items>
                      <v-btn dark text @click="dialog = false">Cerrar</v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :calculate-widths="true"
                        dense
                        :items="pacsOtrosCpcs"
                        :headers="headers"
                        class="elevation-1"
                        style="font-size:10px"
                        :loading="loading"
                        loading-text="Cargando... Por favor espere"
                        :mobile-breakpoint="100"
                      >
                        <template v-slot:item.ano="{ item }">
                          <div style="width:77px" class="text-center">
                            {{ item.ano }}<br />
                            <v-chip small outlined>
                              {{ item.periodo }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:item.nombre_entidad="{ item }">
                          <div style="width:270px">
                            {{ item.nombre_entidad }}
                            {{
                              item.nombre_entidad !=
                              item.nombre_comercial_entidad
                                ? ` [${item.nombre_comercial_entidad}]`
                                : ""
                            }}
                            <br />
                            <v-chip small outlined>
                              <v-icon small left>mdi-map-marker</v-icon>
                              {{ item.provincia_entidad }} /
                              {{ item.canton_entidad }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:item.descripcion="{ item }">
                          <div class="py-2">
                            <v-chip small outlined class="mr-1">
                              {{ item.procedimiento | uppercase }}
                            </v-chip>
                            <v-chip small outlined>
                              {{ item.pac_tipo | uppercase }}
                            </v-chip>
                            <text-highlight :queries="queries">
                              {{ item.descripcion }}
                            </text-highlight>
                            <v-divider
                              class="my-2 white background"
                            ></v-divider>
                            <strong>CPC NIVEL 5: </strong>

                            <text-highlight :queries="queries">
                              {{ item.descripcion_cpc }}</text-highlight
                            >

                            <v-divider class="my-2 background"></v-divider>
                            <strong>CPC NIVEL 9: </strong>

                            <text-highlight :queries="queries">{{
                              item.descripcion_cpc_full
                            }}</text-highlight>
                          </div>
                        </template>
                        <template v-slot:item.pac_total="{ item }">
                          <v-row no-gutters style="width:150px">
                            <v-col>Cant.</v-col>
                            <v-col class="text-right">{{
                              item.pac_cantidad | currency("")
                            }}</v-col>
                          </v-row>
                          <v-row no-gutters style="width:150px">
                            <v-col>Medida.</v-col>
                            <v-col class="text-right">{{
                              item.pac_medida
                            }}</v-col>
                          </v-row>
                          <v-row no-gutters style="width:150px">
                            <v-col>V. Unit</v-col>
                            <v-col class="text-right">{{
                              item.pac_costo_unitario | currency
                            }}</v-col>
                          </v-row>
                          <v-row no-gutters style="width:150px">
                            <v-col><strong>Total</strong></v-col>
                            <v-col
                              style="border-top:1px solid"
                              class="text-right"
                            >
                              <strong
                                >{{ item.pac_total | currency }}
                              </strong></v-col
                            >
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="mb-4">
      <v-btn-toggle
        v-model="toggle_exclusive"
        mandatory
        color="primary"
        @change="loadData"
      >
        <v-btn text value="todos">
          Todos
        </v-btn>
        <v-btn text value="ejecutados">
          Ejecutados
        </v-btn>
        <v-btn text value="noejecutados">
          No Ejecutados
        </v-btn>
      </v-btn-toggle>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :calculate-widths="true"
          dense
          :items="pacsMisCpcs"
          :headers="headers"
          class="elevation-1"
          style="font-size:10px"
          :loading="loading"
          loading-text="Cargando... Por favor espere"
          :mobile-breakpoint="100"
        >
          <template v-slot:item.ano="{ item }">
            <div style="width:77px" class="text-center">
              {{ item.ano }}<br />
              <v-chip small outlined>
                {{ item.periodo }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.nombre_entidad="{ item }">
            <div style="width:270px">
              {{ item.nombre_entidad }}
              {{
                item.nombre_entidad != item.nombre_comercial_entidad
                  ? ` [${item.nombre_comercial_entidad}]`
                  : ""
              }}
              <br />
              <v-chip small outlined>
                <v-icon small left>mdi-map-marker</v-icon>
                {{ item.provincia_entidad }} / {{ item.canton_entidad }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.descripcion="{ item }">
            <div class="py-2">
              <v-chip small outlined class="mr-1">
                {{ item.procedimiento | uppercase }}
              </v-chip>
              <v-chip small outlined>
                {{ item.pac_tipo | uppercase }}
              </v-chip>
              <text-highlight :queries="queries">
                {{ item.descripcion }}
              </text-highlight>
              <v-divider class="my-2 background"></v-divider>
              <strong>CPC NIVEL 5: </strong>

              <text-highlight :queries="queries">
                {{ item.descripcion_cpc }}</text-highlight
              >

              <v-divider class="my-2 background"></v-divider>
              <strong>CPC NIVEL 9: </strong>

              <text-highlight :queries="queries">{{
                item.descripcion_cpc_full
              }}</text-highlight>
            </div>
          </template>
          <template v-slot:item.pac_total="{ item }">
            <v-row no-gutters style="width:150px">
              <v-col>Cant.</v-col>
              <v-col class="text-right">{{
                item.pac_cantidad | currency("")
              }}</v-col>
            </v-row>
            <v-row no-gutters style="width:150px">
              <v-col>Medida.</v-col>
              <v-col class="text-right">{{ item.pac_medida }}</v-col>
            </v-row>
            <v-row no-gutters style="width:150px">
              <v-col>V. Unit</v-col>
              <v-col class="text-right">{{
                item.pac_costo_unitario | currency
              }}</v-col>
            </v-row>
            <v-row no-gutters style="width:150px">
              <v-col><strong>Total</strong></v-col>
              <v-col style="border-top:1px solid" class="text-right">
                <strong>{{ item.pac_total | currency }} </strong></v-col
              >
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import TextHighlight from "vue-text-highlight";
import Excell from "@/components/Excell";
import unzipHeadersAndRows from "@/services/elastic/response/jsonUtils";

export default {
  name: "Dashboard",
  components: {
    TextHighlight,
    Excell
  },
  data() {
    return {
      pacsMisCpcs: [],
      pacsOtrosCpcs: [],
      toggle_exclusive: undefined,
      loading: false,
      dialog: false,
      xlsxHeaders: [
        "AÑO",
        "PERIODO",
        "ENTIDAD CONTRATANTE",
        "PROCEDIMIMIENTO",
        "TIPO COMPRA",
        "DESCRIPCION",
        "CPC NIVEL 5",
        "CPC NIVEL 9",
        "PROVINCIA",
        "CANTON",
        "CANTIDAD",
        "MEDIDA",
        "VALOR UNITARIO",
        "TOTAL"
      ],
      xlsxFields: [
        "ano",
        "periodo",
        "nombre_entidad",
        "procedimiento",
        "pac_tipo",
        "descripcion",
        "descripcion_cpc",
        "descripcion_cpc_full",
        "provincia_entidad",
        "canton_entidad",
        "pac_cantidad",
        "pac_medida",
        "pac_costo_unitario",
        "pac_total"
      ],
      headers: [
        { text: "AÑO PERIODO", value: "ano" },
        { text: "CONTRATANTE", value: "nombre_entidad" },
        { text: "DESCRIPCIÓN DE LA COMPRA", value: "descripcion" },
        { text: "CANTIDADES Y PRECIOS", value: "pac_total" },
        { text: "ESTADO", value: "estado" }
      ],
      logger: {}
    };
  },
  computed: {
    ...mapGetters([
      "filters"
      // ...
    ]),
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    moreItems() {
      return this.pacsOtrosCpcs.length > 0 ? true : false;
    },
    queries() {
      return this.flatten(
        this.$store.getters.filters
          .filter(
            filtro =>
              filtro.field.value == "descripcion" ||
              filtro.field.value == "descripcion_cpc" ||
              filtro.field.value == "descripcion_cpc_full"
          )
          .map(filter => filter.param.replace(/[*()]/g, "").split(" "))
      ).filter(filtro => filtro.length > 2);
    },
    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    },
    misCpcs: function() {
      return this.$store.getters.misCpcs;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      }
    }
  },
  methods: {
    flatten(arr) {
      return Array.prototype.concat(...arr);
    },
    loadData: async function() {
      console.log("Loading data..");
      this.pacsMisCpcs = [];
      this.loading = true;
      try {
        let { pacsMisCpcs, pacsOtrosCpcs } = await postDashboard();
        //let { cursor } = pacsMisCpcs;
        this.pacsMisCpcs = unzipHeadersAndRows(pacsMisCpcs);
        this.pacsOtrosCpcs = pacsOtrosCpcs
          ? unzipHeadersAndRows(pacsOtrosCpcs)
          : [];
      } catch (e) {
        console.log(e);
        //this.setError(e);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
